export default {
  rules: 'กฎกติกา',
  functions: 'ฟังก์ชันก่อนการประมวลผล',
  addRule: 'เพิ่มกฎกติกา',
  help: 'ความช่วยเหลือ',
  operatorCockpit: 'โต๊ะควบคุมของผู้ประกอบการ',
  weekStart: 'วันเริ่มต้นของสัปดาห์',
  cockpitType: 'ประเภทของโต๊ะควบคุม',
  cockpitLayout: 'รูปแบบการจัดวางของโต๊ะควบคุม',
  countingOEE: 'การคำนวณ OEE',
  maxPerformance: 'ประสิทธิภาพสูงสุดทันที',
  maxPerformanceInfo: 'ใช้ในการตรวจสอบค่าคอนเตอร์, เพื่อตรวจสอบว่าค่าเคาน์เตอร์ใหม่เป็นไปได้ (0 = ปิดการใช้งานการความปลอดภัย)',
  excludeOEE: 'ยกเว้น OEE',
  thresholds: 'ค่าเกณฑ์',
  saved: 'บันทึกแล้ว',
  baseUnit: 'หน่วยฐาน',
  baseOrderUnit: 'หน่วยคำสั่งเริ่มต้น',
  notSelected: 'ไม่ได้เลือก',
  saveFailed: 'บันทึกล้มเหลว',
  addMachine: 'เพิ่มเครื่องจักรในตัวกรอง',
  noCounter: 'เครื่องจักรไม่มีเคาน์เตอร์',
  machineBaseUnitSetInCounter: 'หน่วยเครื่องจักรถูกกำหนด',
  shortPerformancePeriod: 'โดยหน่วยของเคาน์เตอร์',
  setupIssues: 'ระยะเวลา',
  noIssuesDetected: 'ปัญหาการติดตั้ง',
  test: 'ไม่พบปัญหาการกำหนดค่า',
  isDummy: 'ทดสอบ',
  isDummyInfo: 'เป็นเครื่องจำลอง',
  maxTimeBufferOffset: 'หยุดความล่าช้าหลังจากเครื่องจักรก่อนหน้านี้',
  maxTimeBufferOffsetInfo: 'หากเครื่องจักรก่อนหน้าหยุดทำงาน, ใช้เวลากี่ชั่วโมงให้เครื่องจักรนี้หยุดทำงานได้',
  rootCauseDelay: 'ความล่าช้าของสาเหตุหลัก',
  rootCauseDelayInfo: 'เครื่องจักรนี้สามารถเสียล่าช้าได้ถึงเวลาใด ให้เครื่องจักรอื่นยังชี้ไปที่เครื่องจักรนี้เป็นสาเหตุหลักได้?',
  signalNameError: 'ชื่อสัญญาณไม่สามารถมีตัวอักษร "(" และ ")" ได้',
  rule: {
    rule: 'กฎ', condition: 'เงื่อนไข', addAndCondition: 'และ', showAdvanced: 'ใช้ตัวแก้ไขขั้นสูง', info: "สถานะเครื่องจักรจะถูกกำหนดตามกฎด้านล่าง เมื่อมีการเปลี่ยนแปลงค่าสัญญาณ ระบบกฎจะวิเคราะห์กฎด้านล่างเริ่มต้นจากลำดับความสำคัญสูงสุด กฎแรกที่ส่งค่า 'true' จะกำหนดสถานะใหม่", ruleType: 'ประเภทของกฎ', eventType: 'เงื่อนไขง่าย', cSharpType: 'ฟังก์ชัน C#', timeBasedRule: 'กฎที่อ้างอิงตามเวลา', script: 'สคริปต์',
  },
  events: { forcedOnly: 'เฉพาะที่บังคับ', showSystem: 'แสดงเหตุการณ์ระบบ' },
  tooltipState: {
    lack: 'สถานะนี้ปรากฏขึ้นเมื่อเครื่องของคุณไม่ได้รับส่วนประกอบที่เพียงพอสำหรับการทำงานต่อเนื่อง ปัญหาอาจเกิดจากลำเลียงที่มีปัญหา ผู้ประกอบการที่ไม่เติมส่วนประกอบตรงเวลา หรือการจัดเก็บส่วนประกอบที่ห่างจากเส้นการผลิตไกลเกินไป', work: 'สถานะนี้ปรากฏเมื่อเครื่องของคุณทำงานอย่างถูกต้องและกระบวนการผลิตกำลังดำเนินอยู่', inactive: 'นี่เป็นสถานะที่เป็นกลางที่ PackOS ใช้สำหรับเครื่องของคุณเมื่อไม่มีความล้มเหลวแต่เครื่องไม่ทำงาน', stop: 'สถานะนี้แสดงว่าเครื่องของคุณถูกหยุดโดยเจ้าหน้าที่โรงงานเพื่อตั้งค่าหรือทำความสะอาด เมื่อเครื่องของคุณอยู่ในสถานะนี้ PackOS จะแสดงปัญหาที่เกิดขึ้นก่อนที่สถานะ "หยุดโดยผู้ใช้งาน" จะมีผลเข้าสู่การใช้งาน', failure: 'สถานะนี้แสดงว่าเครื่องของคุณหยุดหรือไม่ทำงานอย่างถูกต้องเนื่องจาก เช่น สภาพที่สึกหรอ หรือข้อผิดพลาดของผู้ประกอบการ ในกรณีนี้แหล่งของปัญหาคือปัญหาที่เกิดขึ้นก่อนที่จะปรากฏสถานะ "ล้มเหลว"', off: 'สถานะนี้ปรากฏเมื่อเครื่องของคุณถูกตัดการเชื่อมต่อ เช่น การตัดไฟหรือเครื่องของคุณสูญเสียการเชื่อมต่อกับไดรเวอร์', idle: 'สถานะนี้แสดงเมื่อเครื่องของคุณไม่ทำงาน แม้ว่าจะไม่เสียหายและไม่มีปัญหากับเครื่องนั้น PackOS จะหาแหล่งของปัญหาโดยการตรวจสอบเครื่องจักรหลัก', nolivedata: 'นี่เป็นสถานะชั่วคราวที่ปรากฏขึ้นเมื่อ PackOS สูญเสียการเชื่อมต่อกับโรงงานชั่วคราว เช่น เนื่องจากปัญหาการเชื่อมต่ออินเทอร์เน็ต PackOS แสดงสถานะนี้เฉพาะชั่วคราวและเปลี่ยนแปลงให้เป็นสถานะ "การดำเนินงาน" อื่นๆ อย่างรวดเร็ว', holdup: 'สถานะนี้ปรากฏเมื่อเครื่องของคุณไม่ทำงานเนื่องจากส่วนผลิตภัณฑ์ถูกบล็อก เป็นที่ซึ่งโดยทั่วไปเป็นเครื่องจักรที่ต่อจากเครื่องจักรด้านล่าง PackOS จะหาแหล่งของปัญหาโดยการตรวจสอบเครื่องจักรด้านล่าง และแหล่งของปัญหาในเครื่องจักรด้านล่างจะถูกคัดลอกให้เป็นสถานะและปัญหาสำหรับเครื่องจักรที่มีสถานะ "การ block"', changeover: 'สถานะนี้ปรากฏเมื่อเครื่องของคุณหยุดเพราะเส้นการผลิตหรือเครื่องถูกปรับเพื่อกระบวนการผลิตใหม่ (เปลี่ยนงาน)',
  },
  shortPerformance: 'ประสิทธิภาพทันที',
  shortPerformanceInfo: 'ประสิทธิภาพทันทีที่คำนวณขึ้นตามการเพิ่มผลิตภัณฑ์เฉลี่ยล่าสุด',
  value: 'ค่า',
  priority: 'ลำดับความสำคัญ',
  dayOfWork: 'วันทำงาน',
  plantConfiguration: 'การกำหนดค่าโรงงาน',
  machineSignals: 'สัญญาณเครื่องจักร',
  signals: 'สัญญาณ',
  signalsExport: 'ส่งออกสัญญาณ',
  logixGateConfigExport: 'ส่งออกการกำหนดค่า LogixGate',
  signalsImport: 'นำเข้าสัญญาณ',
  workEventsImport: 'นำเข้าปัญหา',
  csvImport: 'นำเข้า CSV',
  csvExport: 'ส่งออก CSV',
  properties: 'คุณสมบัติ',
  signalsAndProperties: 'สัญญาณและคุณสมบัติ',
  machineLicenses: 'ใบอนุญาตเครื่องจักร',
  addSignal: 'เพิ่มสัญญาณ',
  addProperty: 'เพิ่มคุณสมบัติ',
  electricity: 'ไฟฟ้า',
  electricityBaseline: 'เส้นใต้ของการใช้พลังงานไฟฟ้า',
  electricityMax: 'ค่าเฉลี่ยสูงสุดของการใช้พลังงานไฟฟ้า',
  shiftDefinitions: 'กำหนดกะการทำงาน',
  info: 'ข้อมูล',
  deleteInfo: "กดปุ่ม 'บันทึก' เพื่อลบ",
  timezone: 'เขตเวลา',
  yourCurrent: 'ปัจจุบันของคุณ',
  differentTimezoneInfo: 'คุณอยู่ในเขตเวลาที่แตกต่างกับโรงงาน!',
  differentTimezoneSettingsInfo: 'การตั้งค่าด้านล่างนี้จะใช้กับเขตเวลาของโรงงาน',
  differentTimezoneSelectorInfo: 'เราจะแสดงเวลาที่แปลงเป็นเขตเวลาของคุณ',
  differentialWaste: 'การสูญเสียที่แตกต่าง',
  wasteBaseDiffCounter: 'เครื่องจักรหลักที่ใช้ในการคำนวณการสูญเสียที่แตกต่าง',
  disableBufferResetBetweenOrders: 'ปิดใช้งานการรีเซ็ตบัฟเฟอร์ระหว่างคำสั่งซื้อ',
  workingHours: 'ชั่วโมงทำงาน',
  addNewShift: 'เพิ่มกะใหม่',
  productionExpectations: 'เป้าหมายการผลิต',
  doYouWantToDelete: 'คุณต้องการลบหรือไม่',
  newShift: 'กะใหม่',
  editShift: 'แก้ไขกะ',
  removeShift: 'ลบกะ',
  users: 'ผู้ใช้',
  nothingToAdd: 'ไม่มีอะไรที่จะเพิ่ม',
  attachedLinesAndMachines: 'สายการผลิตและเครื่องจักรที่แนบ',
  addLineOrMachine: 'เพิ่มสายการผลิต / เครื่องจักร',
  layout: 'การจัดวาง',
  saveLayout: 'บันทึกเค้าโครง',
  elementsOrder: 'ลำดับองค์ประกอบ',
  advanced: 'ขั้นสูง',
  default: 'ค่าเริ่มต้น',
  noLayoutLine: 'สายการผลิตไม่ได้กำหนดในเค้าโครงของโรงงาน',
  units: 'หน่วย',
  unitCode: 'รหัสหน่วย',
  isBaseUnit: 'เป็นหน่วยหลักหรือไม่',
  fromUnit: 'หน่วยหลักย่อย',
  toUnit: 'หน่วยหลัก',
  multiplier: 'ตัวคูณ',
  shortName: 'ชื่อย่อ',
  blockCard: 'บล็อกการ์ด',
  activeSince: 'ใช้งานตั้งแต่',
  production: 'การผลิต',
  card: 'การ์ด',
  cardId: 'รหัสการ์ด',
  cardPin: 'รหัส PIN ของการ์ด',
  oldPin: 'รหัส PIN ก่อนหน้า',
  newPin: 'รหัส PIN ใหม่',
  pinChange: 'เปลี่ยนรหัส PIN',
  pinLengthError: 'รหัส PIN ต้องมีเลข 4 หลักเท่านั้น',
  cardIdLengthError: 'รหัสการ์ดต้องมีอักขระอย่างน้อย 4 ตัวอักษร',
  connections: 'กระแส',
  displaySettings: 'แสดงผล',
  adminPlantSettings: 'การตั้งค่าโรงงานของผู้ดูแลระบบ',
  orderAutostartThreshold: 'เริ่มคำสั่งซื้ออัตโนมัติ',
  forcedStateThreshold: 'สิ้นสุดเวลาหยุดอัดแรง',
  downtimeThreshold: 'ล็อกเคาน์เตอร์เวลาหยุด',
  allowProductionOnDowntime: 'อนุญาตการผลิตระหว่างเวลาหยุด',
  minorStopThreshold: 'ค่าเกณฑ์ของหยุดระหว่างการผลิตที่เล็กน้อย',
  designPerformanceInfo: 'ประสิทธิภาพของเครื่องจักรที่สามารถบรรลุได้ตามที่ผู้ผลิตระบุ',
  validatedPerformanceInfo: 'ประสิทธิผลของเครื่องจักรที่วัดและตรวจสอบในสภาพแวดล้อมจริง',
  orderAutostartThresholdInfo: 'ค่าเกณฑ์ที่กำหนดระดับการผลิตที่จำเป็นในการเริ่มคำสั่งซื้อโดยอัตโนมัติ',
  forcedStateThresholdInfo: 'ค่าเกณฑ์ที่กำหนดระดับการผลิตที่จำเป็นในการสิ้นสุดเวลาหยุดอัดแรงโดยอัตโนมัติ',
  downtimeThresholdInfo: 'ค่าเกณฑ์ที่กำหนดระดับการผลิตที่จำเป็นในการสิ้นสุดเวลาหยุด ระหว่างเวลาหยุดแต่งตัว การผลิตจะไม่เปลี่ยนไปยังเวลาหยุดอื่นหรืองานอื่น จนกว่าจะมีการลงทะเบียนผลิตภัณฑ์จำนวนที่ระบุ',
  calculateEnergyFromMachines: 'คำนวณพลังงานจากเครื่องจักร',
  expectations: {
    expectedOee: 'OEE ที่คาดหวัง', expectedPerformance: 'ประสิทธิผลที่คาดหวัง', maxExpectedFailures: 'จำนวนครั้งที่คาดหวังในการล้มเหลวสูงสุด', validatedPerformance: 'ประสิทธิผลที่ได้รับการตรวจสอบแล้ว', designPerformance: 'ประสิทธิผลการออกแบบ',
  },
  automation: { automation: 'อัตโนมัติ', add: 'เพิ่มการอัตโนมัติ', type: { CreateQuestOnWorkEvent: { title: 'สร้างงาน', description: 'สร้างงานเมื่อเกิดปัญหาประเภทนี้บนเครื่องจักร' }, CreateAndCloseQuestOnWorkEvent: { title: 'สร้างงานเมื่อเกิดปัญหาประเภทนี้บนเครื่องจักรและปิดงานโดยอัตโนมัติเมื่อปัญหาหยุด', description: 'สร้างงานทันทีเมื่อประเภทของปัญหาเกิดขึ้นที่เครื่องจักรและปิดงานอัตโนมัติเมื่อปัญหาหยุดเกิดขึ้น' } } },
  taxonomy: { taxonomy: 'การจัดหมวดหมู่' },
  unit: { usedInPackageStructure: 'ไม่สามารถลบหน่วยได้ เนื่องจากมีการใช้งานในการกำหนดโครงสร้างของแพ็คเกจ', fieldsNotValid: 'รูปแบบฟิลด์ไม่ถูกต้อง' },
  sku: { expectedEffort: 'ความพยายามที่คาดหวัง (ชั่วโมง)', skuDescriptionTooltip: 'หากเว้นว่างไว้ จะใช้คำอธิบาย SKU' },
  function: {
    sessionName: 'ชื่อเซสชัน', sessionInfo: 'ฟังก์ชันที่ใช้ชื่อเซสชันเดียวกันจะถูกดำเนินการต่อเนื่อง (ไม่ใช่พร้อมกัน)', run: 'เริ่ม', testValue: 'ค่าทดสอบ', testResult: 'ผลทดสอบ', triggers: 'ตัวกระตุ้น', script: 'สคริปต์', isStateful: 'มีสถานะ', sequenceProcessing: 'ประมวลผลตามแท็กต่อเนื่องกัน', newFunction: 'เพิ่มฟังก์ชัน', editFunction: 'แก้ไขฟังก์ชัน',
  },
  energy: 'พลังงาน',
  setUrl: 'บันทึก URL ใหม่',
  authUrl: 'ที่อยู่ URL สำหรับการยืนยันตัวตน',
  loadedOnNextLogin: 'จะถูกโหลดหลังจากการเข้าสู่ระบบครั้งถัดไป',
  allTypes: 'ทุกประเภท',
};
